import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FieldArray, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { ResumeEducationSchema } from "../../../validation/validator";
import Form from "react-bootstrap/Form";
import { RootState } from "../../../store/store";
import { setResumeDetails } from "../../../store/resume.store";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { AppRoute } from "../../../router/routerConstants";
import moment from "moment";

interface Education {
  from: Date | null;
  to: Date | null;
  fieldofstudy: string;
  degree: string;
  college: string;
  city: string;
}

interface Educations {
  educations: Education[];
}
const AddEducationModal = ({
  show,
  isBulkEdit,
  isSingleEdit,
  onClose,
  getEducationList,
}: any) => {
  const dispatch = useDispatch();

  const { resumeDetails } = useSelector(
    (state: RootState) => state.resumeSlice
  );
  const { user } = useSelector((state: RootState) => state.authSlice);
  const [NavigateTo] = useCustomNavigate();

  const defaultEducations = {
    educations: [
      {
        from: null,
        to: null,
        fieldofstudy: "",
        degree: "",
        college: "",
        city: "",
      },
    ],
  };

  const [educationInfo, setEducationInfo] =
    useState<Educations>(defaultEducations);

  useEffect(() => {
    if (isSingleEdit && getEducationList) {
      setEducationInfo({ educations: getEducationList.educations });
    } else if (resumeDetails?.educations && isBulkEdit) {
      setEducationInfo({ educations: resumeDetails?.educations });
    } else {
      setEducationInfo(defaultEducations);
    }
    // eslint-disable-next-line
  }, [resumeDetails, getEducationList, isBulkEdit, isSingleEdit]);

  const handleSubmit = (values: any) => {
    const updatedEducations =
      values.educations &&
      values.educations.map((exp: Education) => ({
        ...exp,
        from: exp.from ? moment(exp.from).format("YYYY-MM-DD") : null,
        to: exp.to ? moment(exp.to).format("YYYY-MM-DD") : null,
      }));

    if (isBulkEdit) {
      const updatedDetails = {
        ...resumeDetails,
        educations: updatedEducations,
      };

      dispatch(setResumeDetails(updatedDetails));
    }

    if (isSingleEdit && Array.isArray(getEducationList?.educations)) {
      if (
        resumeDetails?.educations &&
        Array.isArray(resumeDetails.educations)
      ) {
        const targetEducation = getEducationList?.educations[0];
        const updatedEducationIndex = resumeDetails?.educations?.findIndex(
          (exp: Education) =>
            Object.keys(targetEducation).every(
              (key) =>
                exp[key as keyof Education] ===
                targetEducation[key as keyof Education]
            )
        );

        if (updatedEducationIndex !== -1) {
          const updatedDetails = {
            ...resumeDetails,
            educations:
              resumeDetails.educations &&
              resumeDetails.educations.map((exp: Education, index: number) =>
                index === updatedEducationIndex
                  ? { ...exp, ...updatedEducations[0] }
                  : exp
              ),
          };

          dispatch(setResumeDetails(updatedDetails));
        }
      }
    }

    if (!isBulkEdit && !isSingleEdit) {
      const updatedDetails = {
        ...resumeDetails,
        // educations: updatedEducations,// updated on 13june25 by pratick
        educations: [...(resumeDetails?.educations || []), ...updatedEducations]
      };

      dispatch(setResumeDetails(updatedDetails));
      onClose();

      if (user && user?.role === "jobseeker") {
        NavigateTo(AppRoute.JOBSEEKER_AFTER_ADDED_EDUCATION);
      } else if (user && user?.role === "localagents") {
        NavigateTo(AppRoute.AGENT_AFTER_ADDED_EDUCATION);
      }
    }
    onClose();
  };

  const getFieldError = (
    errors: any,
    field: string,
    index: number
  ): string | undefined => {
    if (
      errors.educations?.[index] &&
      typeof errors.educations[index] === "object"
    ) {
      return errors.educations[index][field];
    }
    return undefined;
  };

  return (
    <Modal
      show={show}
      onHide={onClose} // Closes modal on cross or outside click
      // backdrop="static" // Prevent close on clicking outside
      keyboard={false} // Prevent close with the keyboard (Esc)
      animation={false}
      aria-labelledby="contained-modal-title-vcenter"
      className="editPersonalInformation"
      centered
    >
      <button
        type="button"
        className="btn-close custom-close-btn"
        onClick={onClose}
        aria-label="Close"
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          zIndex: 9,

          border: "none",
          fontSize: "1rem",
          cursor: "pointer",
        }}
      ></button>
      <Modal.Body>
        <div className="findbody">
          <h3>
            {isBulkEdit || isSingleEdit ? "Edit" : "Add"} Education Information
          </h3>
          <Formik
            initialValues={educationInfo}
            enableReinitialize={true}
            validationSchema={ResumeEducationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
            }) => (
              <Form className="modalSearch" onSubmit={handleSubmit}>
                <FieldArray
                  name="educations"
                  render={(arrayHelpers) => (
                    <div>
                      {values?.educations &&
                        values?.educations?.map(
                          (education: Education, index: number) => (
                            <div key={index} className="work-experience-form">
                              <Form.Group className="mb-3">
                                <Form.Label>From</Form.Label>
                                <Form.Control
                                  type="date"
                                  name={`educations.${index}.from`}
                                  value={
                                    education.from
                                      ? moment(education.from).format(
                                          "YYYY-MM-DD"
                                        )
                                      : ""
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Starting date"
                                  max={moment().format("YYYY-MM-DD")}
                                />
                                {getFieldError(errors, "from", index) &&
                                  touched.educations?.[index]?.from && (
                                    <div className="text-danger">
                                      {getFieldError(errors, "from", index)}
                                    </div>
                                  )}
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>To</Form.Label>
                                <Form.Control
                                  type="date"
                                  name={`educations.${index}.to`}
                                  value={
                                    education.to
                                      ? moment(education.to).format(
                                          "YYYY-MM-DD"
                                        )
                                      : ""
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Ending date"
                                  max={moment().format("YYYY-MM-DD")}
                                />
                                {getFieldError(errors, "to", index) &&
                                  touched.educations?.[index]?.to && (
                                    <div className="text-danger">
                                      {getFieldError(errors, "to", index)}
                                    </div>
                                  )}
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>Field of Study</Form.Label>
                                <Form.Control
                                  type="text"
                                  name={`educations.${index}.fieldofstudy`}
                                  value={education.fieldofstudy}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter your field of study"
                                />
                                {getFieldError(errors, "fieldofstudy", index) &&
                                  touched.educations?.[index]?.fieldofstudy && (
                                    <div className="text-danger">
                                      {getFieldError(
                                        errors,
                                        "fieldofstudy",
                                        index
                                      )}
                                    </div>
                                  )}
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>Degree Obtained</Form.Label>
                                <Form.Select
                                  className="form-control"
                                  aria-label="Default select example"
                                  name={`educations.${index}.degree`}
                                  value={education.degree}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <option value="">Select your degree</option>
                                  <option value="b.sc">B.SC</option>
                                  <option value="b.tech">B.Tech</option>
                                  <option value="mca">MCA</option>
                                </Form.Select>
                                {getFieldError(errors, "degree", index) &&
                                  touched.educations?.[index]?.degree && (
                                    <div className="text-danger">
                                      {getFieldError(errors, "degree", index)}
                                    </div>
                                  )}
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>School/College Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  name={`educations.${index}.college`}
                                  value={education.college}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter your school name"
                                />
                                {getFieldError(errors, "college", index) &&
                                  touched.educations?.[index]?.college && (
                                    <div className="text-danger">
                                      {getFieldError(errors, "college", index)}
                                    </div>
                                  )}
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>City</Form.Label>
                                <Form.Control
                                  type="text"
                                  name={`educations.${index}.city`}
                                  value={education.city}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter your city"
                                />
                                {getFieldError(errors, "city", index) &&
                                  touched.educations?.[index]?.city && (
                                    <div className="text-danger">
                                      {getFieldError(errors, "city", index)}
                                    </div>
                                  )}
                              </Form.Group>

                              {values.educations.length > 1 && (
                                <Button
                                  variant="danger"
                                  className="mb-3"
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  Remove
                                </Button>
                              )}
                            </div>
                          )
                        )}
                      <div className="d-flex gp-10">
                        {!isSingleEdit && (
                          <Button
                            className="btn btn-black w-100"
                            onClick={() =>
                              arrayHelpers.push({
                                from: null,
                                to: null,
                                fieldofstudy: "",
                                degree: "",
                                college: "",
                                city: "",
                              })
                            }
                          >
                            Add More
                          </Button>
                        )}

                        <Button className="btn w-100" type="submit">
                          {isSingleEdit || isBulkEdit ? "Update" : "Save"}
                        </Button>
                      </div>
                    </div>
                  )}
                />
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddEducationModal;
